import type { AccountInfo } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

import { authService } from '~libs';
import { useAuthStore } from '~store';

type AuthState = {
  /** The active user account, or null if not authenticated */
  readonly account: AccountInfo | null;
  /** MSAL instance for authentication operations */
  readonly instance: ReturnType<typeof useMsal>['instance'];
  /** All available user accounts */
  readonly accounts: AccountInfo[];
  /** Signs out the current user and redirects */
  readonly logout: () => void;
};

const useAuth = (): AuthState => {
  const { accounts, instance } = useMsal();

  const account = useAuthStore((state) => state.account);

  const logout = useCallback(() => {
    authService.clearAuth();
    instance.logoutRedirect().catch(console.error);
  }, [instance]);

  return {
    account,
    instance,
    accounts,
    logout,
  };
};

export { type AuthState, useAuth };
